import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ErrorObj } from "../utils/types";
import greaterThan from '../assets/greaterthan.svg';

// Props type definition
interface DetailFormProps {
  userName: string;
  setUserName: (value: string) => void;
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  email: string;
  setEmail: (value: string) => void;
  emailVerified: number;
  setEmailVerified: (value: any) => void;
  phoneVerified: number;
  setPhoneVerified: (value: any) => void;
  otpSent: boolean;
  setOtpSent: (value: boolean) => void;
  otp: string;
  setOtp: (value: string) => void;
  handleSendOtp: (choice: any) => Promise<boolean>;
  handleOtpValidation: (choice: any) => Promise<boolean>;
  handleSignup: () => void;
  signupLoading?: boolean;
  isOtpMatched: boolean;
  setIsOtpMatched: (value: boolean) => void;
  password: string;
  setPassword: (value: string) => void;
  error: ErrorObj;
  setError: (value: any) => void;
  verifyError: string;
  setVerifyError: (value: any) => void;
  requestAccessLink: boolean;
}

const AuthDetailForm: React.FC<DetailFormProps> = ({
  userName,
  setUserName,
  phoneNumber,
  setPhoneNumber,
  email,
  setEmail,
  emailVerified,
  setEmailVerified,
  phoneVerified,
  setPhoneVerified,
  otpSent,
  setOtpSent,
  otp,
  setOtp,
  handleSendOtp,
  handleSignup,
  signupLoading = false,
  handleOtpValidation,
  isOtpMatched,
  setIsOtpMatched,
  password,
  setPassword,
  error,
  setError,
  verifyError,
  setVerifyError,
  requestAccessLink,
}) => {
  const [confirmPassword, setConfirmPassword] = useState("");
  const [magicLinkSentMsg, setMagicLinkSentMsg] = useState("");
  const [sendingLink, setSendingLink] = useState(false);

  const matchPassword = () => {
    setError({});
    if (confirmPassword !== password) {
      setError({
        confirmPassword: "Password does not match",
      });
      return false;
    } else {
      setError({});
      return true;
    }
  };

  const emailValidator = () => {
    setError({});
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email)) {
      setError({
        email: "Please enter a valid email address",
      });
      return false;
    }
    return true;
  };

  const phoneValidator = () => {
    setError({});
    if (!phoneNumber) {
      setError({
        phone: "Please enter a phone number",
      });
      return false;
    }
    const regex = /^(?:\+1[-\.\s]?)?(?:\(?([2-9]\d{2})\)?[-\.\s]?)([2-9]\d{2})[-\.\s]?(\d{4})$/;
    if (!regex.test(phoneNumber)) {
      setError({
        phone: "Enter a valid US phone number",
      });
      return false;
    }
    return true;
  };

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <>
      {error.system && (
        <p className="text-center mt-6 text-[#FF0000]" role="alert">
          {error.system}
        </p>
      )}
      {error.email && (
        <p className="text-center mt-6 text-[#FF0000]" role="alert">
          {error.email}
        </p>
      )}
      {error.password && (
        <p className="text-center mt-6 text-[#FF0000]" role="alert">
          {error.password}
        </p>
      )}

      {error.confirmPassword && (
        <p className="text-center mt-6 text-[#FF0000]" role="alert">
          {error.confirmPassword}
        </p>
      )}
      {verifyError !== "" && (
        <p className="text-center mt-6 text-[#FF0000]" role="alert">
          {verifyError}
        </p>
      )}
      <>
        <label className="mt-4 sr-only" htmlFor="name">
          Enter your Name *
        </label>
        <div style={{ position: "relative" }}>
          <label className="signup-border-label">Name</label>
        </div>
        <input
          className="w-[100%] h-[3.625rem] px-4 mt-4 signup-input input-user"
          id="name"
          type="text"
          placeholder="Enter your Name"
          value={userName}
          onChange={(e) => {
            setUserName(e.target.value);
          }}
          aria-invalid={userName.length < 3}
        />
      </>
      <>
        <label htmlFor="email" className="mt-4 sr-only">
          Email
        </label>
        <div style={{ position: "relative" }}>
          <label className="signup-border-label">Email Address</label>
        </div>
        <input
          className="w-[100%] h-[3.625rem] px-4 mt-4 signup-input input-email"
          id="email"
          type="email"
          placeholder="Enter Email Address"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setError({});
            setVerifyError("");
          }}
          aria-invalid={error.email !== ""}
        />
      </>


      {/* Conditionally render the "Send OTP" button */}
      {/* {(phoneNumber || email) && !otpSent && !isOtpMatched && (
        <button
          onClick={handleSendOtp}
          className={`mt-6 ${
            emailValidator(email) || phoneNumber.length === 10
              ? "bg-[#4f00ec]"
              : "bg-gray-400"
          } w-[640px] h-[50px] rounded`}
          disabled={!emailValidator(email) && phoneNumber.length !== 10}
        >
          Send OTP
        </button>
      )} */}

      {/* Conditionally render the OTP input field */}

      {/* Conditionally render the password field , when OTP is validated */}

      <>
        <label htmlFor="password" className="mt-4 sr-only">
          Enter Password
        </label>
        <div style={{ position: "relative" }}>
          <label className="signup-border-label">Password</label>
        </div>
        <div style={{ position: "relative" }}>
          <input
            className="w-[100%] h-[3.625rem] px-4 mt-4 signup-input input-password"
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Password (8+ characters)"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            minLength={8}
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? "Hide password" : "Show password"}
            style={{
              position: "absolute",
              right: "1rem",
              top: "calc(50% + 0.5rem)",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#6b7280",
              padding: "0.25rem",
              zIndex: 10
            }}
          >
            {showPassword ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858-5.908a10.048 10.048 0 014.122-.963c4.478 0 8.268 2.943 9.542 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21M3 3l18 18" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            )}
          </button>
        </div>
      </>

      <>
        <label htmlFor="cnfpassword" className="mt-4 sr-only">
          Confirm Password
        </label>
        <div style={{ position: "relative" }}>
          <label className="signup-border-label">Confirm Password</label>
        </div>
        <div style={{ position: "relative" }}>
          <input
            className="w-[100%] h-[3.625rem] px-4 mt-4 signup-input input-password"
            id="cnfpassword"
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirm Password (8+ characters)"
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
            }}
            minLength={8}
            required
          />
          <button
            type="button"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            aria-label={showConfirmPassword ? "Hide confirm password" : "Show confirm password"}
            style={{
              position: "absolute",
              right: "1rem",
              top: "calc(50% + 0.5rem)",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#6b7280",
              padding: "0.25rem",
              zIndex: 10
            }}
          >
            {showConfirmPassword ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858-5.908a10.048 10.048 0 014.122-.963c4.478 0 8.268 2.943 9.542 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21M3 3l18 18" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            )}
          </button>
        </div>
      </>
      <button
        className={`mt-12 bg-[#4f00ec] w-[11.25rem] h-[3.25rem] rounded submit-button`}
        onClick={() => {
          if (matchPassword()) {
            handleSignup();
          }
        }}
        disabled={signupLoading}
        aria-busy={signupLoading}
        style={{ opacity: signupLoading ? 0.7 : 1, cursor: signupLoading ? "not-allowed" : "pointer" }}
      >
        {signupLoading ? "Registering..." : "Signup"}
        <img src={greaterThan} alt="" aria-hidden="true" />
      </button>

      <div className="login-link-container">
        <h2 style={{ fontSize: "1rem", fontWeight: 500 }}
              className="mt-12 text-right mb-4">
          Already Have an account ?{" "}
          <Link to="/login" className="text-[#5030E5]" style={{textDecoration:"underline"}}>
            Login Here
          </Link>
        </h2>
      </div>

      {requestAccessLink && (
        <p className="request-access-message mt-6">
          You are Not Authorized to use the system. You either need to enroll in
          Sugamya Pustakalaya, or{" "}
          <Link className="text-[#00DAF7]" to="/requestAccess">
            click here to verify your disability status
          </Link>
        </p>
      )}
      {/* <p className='mt-4'>{error}</p> */}
    </>
  );
};

export default AuthDetailForm;
